import React from "react";

import { RangeInput } from "../../atoms";

export const RangeMolecule = props => {
	return (
		<div className="range-molecule">
			{!props.label || <div className="range-label">{props.label}</div>}
			<RangeInput
				id={props.id}
				min={props.min}
				max={props.max}
				value={props.value || 0}
				changeAction={props.changeAction}
			/>
			<div className="number">{props.value}{!props.value || props.mask}</div>
		</div>
	);
};


// WEBPACK FOOTER //
// src/molecules/lib/RangeMolecule.js